export default __webpack_public_path__ + "static/media/330_private01-it-mobile.594afcb9.png";